<lin-layout-section class="messenger-container" title="{{ 'CLIENT.MESSENGER.TITLE' | translate }}">
  <lin-progress-bar [isShown]="messengerService.isLoading$ | async"></lin-progress-bar>
  <lin-layout-section-toolbar>
    <lin-chat-create-button *ngIf="isChatCreate" [isDefault]="true"></lin-chat-create-button>
  </lin-layout-section-toolbar>
  <div class="messenger">
    <lin-chat-list
      *ngIf="messengerService.isShowList | async"
      [isFullWidth]="(messengerService.isShowDetail | async) === false"
    ></lin-chat-list>
    <div *ngIf="messengerService.isShowDetail | async" class="messenger-details">
      <router-outlet></router-outlet>
    </div>
  </div>
</lin-layout-section>
